import {Component, OnInit} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';

@Component({
  selector: 'tl-privacy-policy',
  templateUrl: './privacy-policy.component.html',
})
export class PrivacyPolicyComponent implements OnInit {
  constructor(
    private title: Title,
    private meta: Meta,
  ) {
  }
  ngOnInit(): void {
    this.title.setTitle('TheLysts, List it, Live it! - Privacy Policy Statement');
    this.meta.updateTag({name: 'description', content: 'There is no accounting for taste, and neither for your list! Our platform is like this: a space for you to organize yourself, express your lifestyle and exchange experiences. You can keep it only for yourself, share with your friends, or the whole world. Read more about this in our Privacy Policy Statement.'});
    this.meta.updateTag({name: 'keywords', content: 'thelysts,lyst,list,task,organizer,privacy,policy,trip,suggestion,music,food,restaurants,sports,movies,films,tv series,podcasts,life style,cars,boats,app,recommendation,planner,beauty,fashion,celebrities,influencers,museums,golf,ongs'});
    this.meta.updateTag({property: 'og:title', content: 'TheLysts, List it, Live it! - Privacy Policy Statement'});
    this.meta.updateTag({property: 'og:image', content: 'https://thelysts.com/og-image/og-image-pp.jpg'});
    this.meta.updateTag({property: 'og:description', content: 'There is no accounting for taste, and neither for your list! Our platform is like this: a space for you to organize yourself, express your lifestyle and exchange experiences. You can keep it only for yourself, share with your friends, or the whole world. Read more about this in our Privacy Policy Statement.'});
  }
}
